import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { addScoreCardSetting, setErrorDescription, setErrorTitle, setIsCreated } from '@application/redux/scoreCard/score-card-slice';
import { DismissFilled } from '@fluentui/react-icons';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import { CriteriaForm } from '@ui/components/Forms';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
const AddNewCriteriaDialog = ({ isOpen, onClose, variant = 'add' }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { scoreCardSetting, errorTitle, errorDescription } = useSelector((state) => state.scoreCardSlice);
    const handleClose = () => {
        onClose();
    };
    const handleSubmit = async () => {
        try {
            const { titleError, descError } = validateScoreCriteriaList(scoreCardSetting);
            if (titleError) {
                dispatch(setErrorTitle(titleError));
            }
            if (descError) {
                dispatch(setErrorDescription(descError));
            }
            if (titleError || descError) {
                return;
            }
            const result = await dispatch(addScoreCardSetting(scoreCardSetting)).unwrap();
            if (result.isSuccess) {
                handleClose();
                dispatch(setIsCreated());
                toast.success(result.message);
            }
        }
        catch (err) {
            toast.error(err instanceof Error ? 'Submission failed' : 'Unknown error occurred');
        }
    };
    function validateScoreCriteriaList(data) {
        let titleError = '';
        let descError = '';
        const titleItem = data.find((item) => item.fieldAndValue.key === 'title' && item.fieldAndValue.value.trim() !== '');
        const descItem = data.find((item) => item.fieldAndValue.key === 'description' && item.fieldAndValue.value.trim() !== '');
        if (!titleItem) {
            titleError = 'Title is required';
        }
        if (!descItem) {
            descError = 'Description is required';
        }
        else if (descItem.fieldAndValue.value.length > 250) {
            descError = 'Description must be 250 characters or less';
        }
        return { titleError, descError };
    }
    return (_jsxs(Dialog, { open: isOpen, onClose: handleClose, maxWidth: 'sm', slotProps: {
            paper: {
                sx: {
                    width: '564px'
                }
            }
        }, fullWidth: true, "aria-labelledby": 'ConfDialog', onKeyDown: (e) => e.key === 'Enter' && {}, children: [_jsxs(DialogTitle, { id: 'add-vehicle-dialog', sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsxs(Typography, { variant: 'h6', color: 'text.primary', children: [variant === 'add' ? 'Add New' : 'Edit', " Criteria"] }), _jsx(IconButton, { onClick: handleClose, children: _jsx(DismissFilled, { fontSize: 18 }) })] }), _jsx(Divider, {}), _jsx(DialogContent, { children: _jsx(Box, { className: 'form-wrapper', sx: { mt: 1 }, children: _jsx(CriteriaForm, {}) }) }), _jsx(Divider, {}), _jsxs(DialogActions, { sx: { p: 3 }, children: [_jsx(Button, { onClick: handleSubmit, variant: 'contained', color: 'inherit', loading: false, type: 'submit', children: t('Save') }), _jsx(Button, { onClick: handleClose, color: 'inherit', variant: 'outlined', children: "Cancel" })] })] }));
};
export default AddNewCriteriaDialog;
